import { FileController } from "@/entities";
import { Panel, PanelHeader, PanelBody } from "@/shared";

interface Props {
  panelTitle: string;
  name: string;
  control: any;
  setValue: any;
  defaultValue: any;
  accept?: string;
}
export function AdminCommonFileCoverWrite({
  panelTitle,
  name,
  control,
  setValue,
  defaultValue,
  accept,
}: Props) {
  return (
    <Panel>
      <PanelHeader>{panelTitle}</PanelHeader>
      <PanelBody className="p-0">
        <FileController
          name={name}
          control={control}
          defaultValue={defaultValue}
          setValue={setValue}
          accept={accept}
        />
      </PanelBody>
    </Panel>
  );
}
